<script setup lang="ts">
import type { ComponentWrapperVideoProps } from "./ComponentWrapperVideo.props"

defineProps<ComponentWrapperVideoProps>()
</script>

<template>
  <div v-if="video" class="cms-wrapper-video py-10">
    <UtilsVideo
      :appVideoClasses="'w-full'"
      :mobileVideoSrc="video?.mobileVideoSrc"
      :videoSrc="video?.videoSrc"
      :hasAutoplay="false"
      :vimeoId="video?.vimeoId ?? undefined"
      :youtubeId="video?.youtubeId ?? undefined"
    ></UtilsVideo>
  </div>
</template>
